<script>
    import AppIcons from "./AppIcons.svelte";
    import { createEventDispatcher } from "svelte";
    import { _log } from "./utils/logger";
    import l from "./utils/locale";

    const dispatch = createEventDispatcher();
    export let name = "";
    export let currentModeItem = "";
    export let isChecked = false;

    $: color = isChecked ? getColorByName() : "white";

    function getColorByName() {
        let result = false;
        switch (name) {
            case "filter":
                result = "blue";
                break;
            case "draw":
                result = "blueviolet";
                break;
            case "resize":
                result = "red";
                break;
            case "autocrop":
                result = "green";
                break;
            case "find":
                result = "darkmagenta";
                break;
        }
        return result;
    }
    function onClickHandler(e) {
        if (isChecked) {
            _log("onClickHandler 1", isChecked, currentModeItem, name);

            if (currentModeItem !== name) {
                _log("onClickHandler 2", isChecked, currentModeItem, name);
                dispatch("click", {
                    data: { isSkip: true, name, isChecked },
                });
            } else {
                isChecked = false;
                dispatch("click", {
                    data: { isChecked, name, disabled: true },
                });
            }
        } else {
            _log("onClickHandler 3", isChecked, currentModeItem, name);
            isChecked = !isChecked;
            dispatch("click", { data: { isChecked, name } });
        }
    }
</script>

<div
    class={`menu-btn noselect ${currentModeItem === name ? "active" : ""}`}
    style={`background-color: ${color}; color:${isChecked ? "white" : "#333"}`}
    on:click={onClickHandler}
>
    <AppIcons {name} {isChecked} />
    <!-- {name} -->
</div>

<style>
    .menu-btn {
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
    }
    .active {
        margin-bottom: -5px;
        transform: scale(1.1);
        box-shadow: 0 -10px 10px var(--trnasparent-black-color);
    }
</style>
